import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';
import { COSTINGS_TIPS } from '@/docs/tips/costings';

export const RepairCostingTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:equipment')}
        thClassName="min-w-[200px] max-sm:min-w-[220px]"
        sortable
        onSortClick={() => onSort?.('equipmentName')}
      />
      <TableHead
        text={t('common:damage')}
        thClassName="min-w-[200px] max-sm:min-w-[250px]"
        sortable
        onSortClick={() => onSort?.('damageName')}
        infoTip={COSTINGS_TIPS.costingDamageColumn}
      />
      <TableHead
        text={t('common:repairService')}
        thClassName="min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('repairServiceName')}
      />
      <TableHead
        text={t('common:cost')}
        thClassName="min-w-[200px]"
        sortable
        onSortClick={() => onSort?.('cost')}
        infoTip={COSTINGS_TIPS.costingCostColumn}
      />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
        infoTip={COSTINGS_TIPS.costingStatusColumn}
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
